import {SwipeableDrawer, Box, List, ListSubheader, Divider, Typography, ListItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import LoginButton from "../../../pages/components/LoginButton";
import {useSession} from "next-auth/react";
import {useRecentActions} from "../context/RecentActionContext";
import DrawersController from "./DrawersControler";


export default function UserDrawer({openUserDrawer, setOpenUserDrawer, setOpenMenu, openMenu}) {
    const {t} = useTranslation('common');
    const {data: session} = useSession();
    const {setOpenDrawer, openDrawer} = useRecentActions();

    const list = () => {
        return (
            <Box
                sx={{backgroundColor: 'primary.main'}}
            >
                <List
                    sx={{width: {xs: '100vw', sm: '55vw', md: '35vw', lg: '20vw'}, justifyContent: 'space-between', alignItems: 'center', overflowX: "hidden", marginRight: 1, height: '100%'}}
                    subheader={
                        <ListSubheader component="div" sx={{backgroundColor: 'primary.main'}}>
                            <DrawersController setOpenDrawer={setOpenDrawer} setOpenUserDrawer={setOpenUserDrawer} setOpenMenu={setOpenMenu} openMenu={openMenu} openDrawer={openDrawer} openUserDrawer={openUserDrawer}/>
                            <Divider />
                        </ListSubheader>}
                >
                    <ListItem sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Typography color='secondary'>{t('header.login.signed-in-label')}: </Typography>
                        <Typography>{session?.user.name}</Typography>

                    </ListItem>
                    <ListItem sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        <Typography>{session?.user.email}</Typography>
                    </ListItem>
                    <ListItem sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        <LoginButton />
                    </ListItem>
                </List>
            </Box>
        );

    };

    return (
        <>
            <SwipeableDrawer
                sx={{
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {height: 'fit-content'},
                }}
                open={openUserDrawer}
                onClose={()=>setOpenUserDrawer(false)}
                onOpen={()=>setOpenUserDrawer(true)}
                anchor='right'>
                {list()}
            </SwipeableDrawer>
        </>
    );
}